import React, { Component } from 'react';
import API from '../../services/API';
import { Row, Col, Button, Pagination } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import MessagesTable from './components/MessagesTable';
import Form from './components/Form';

class ClickBaitMessages extends Component {
    constructor() {
        super();

        this.state = {
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            isLoading: false,
            isShowForm: false,
            selectedMessage: null,
            selectedMessageID: null
        };

        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleDuplicate = this.handleDuplicate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadMessages();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.activePage !== prevState.activePage) this.loadMessages();
    }

    loadMessages() {
        const { activePage } = this.state;
        this.setState({ isLoading: true });

        API.ClickBaitMessages.getPage(activePage).then(res => {
            this.setState({ ...res,  isLoading: false });
        });
    }


    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    message={this.state.selectedMessage}
                />
            );
        }
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedMessage: null,
            selectedMessageID: null,
            action: 'save'
        });
    }

    handleUpdate(messageID) {
        const message = this.state.rows.find(item => item.id === messageID);
        this.setState({
            isShowForm: true,
            selectedMessage: message,
            selectedMessageID: messageID,
            action: 'update'
        });
    }

    handleDuplicate(messageID) {
        const message = this.state.rows.find(item => item.id === messageID);
        this.setState({
            isShowForm: true,
            selectedMessage: message,
            selectedMessageID: messageID,
            action: 'save'
        });
    }

    handleRemove(messageID) {
        this.setState({
            isLoading: true
        });

        API.ClickBaitMessages.remove(messageID).then(() => {
            let { rows } = this.state;
            rows = rows.filter(item => !(item.id === messageID));


            this.setState({
                isLoading: false,
                rows
            });
        });
    }

    handleSync() {
        this.setState({
            isLoading: true
        });

        API.ClickBaitMessages.sync().then(() => {
            this.setState({ isLoading: false });
        });
    }

    handleFormHide() {
        this.setState({
            isShowForm: false
        });
    }

    handleFormSubmit(message) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(this.state.action === 'update') {
            API.ClickBaitMessages.update(this.state.selectedMessageID, message).then(() => this.loadMessages());
        }
        else {
            API.ClickBaitMessages.save(message).then(() => this.loadMessages());
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Segments"/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                        <Button className="pull-right m-b-15 m-r-15" bsStyle="info" onClick={this.handleSync}> Sync</Button>
                    </Col>
                </Row>
                {this.getForm()}
                <MessagesTable
                    messages={this.state.rows}
                    onUpdate={this.handleUpdate}
                    onDuplicate={this.handleDuplicate}
                    onRemove={this.handleRemove}
                />
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default ClickBaitMessages;


// WEBPACK FOOTER //
// ./src/scenes/ClickBaitMessages/index.js